import script from "./multi-select-combobox.vue?vue&type=script&setup=true&lang=js"
export * from "./multi-select-combobox.vue?vue&type=script&setup=true&lang=js"

import "./multi-select-combobox.vue?vue&type=style&index=0&id=65fd4925&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65fd4925"]])

export default __exports__